import { Component, OnDestroy } from '@angular/core'
import { Subscription } from 'rxjs'

import { Portfolio } from './portfolio.model'
import { PortfolioService } from './portfolio.service'

@Component({
  selector: 'portfolio',
  templateUrl: './portfolio.component.html',
  styleUrls: ['./portfolio.component.scss'],
})
export class PortfolioComponent implements OnDestroy {
  portfolioModel: Portfolio
  portfolioSubscription: Subscription
  profileSubscription: Subscription
  equityStyle: boolean
  fixedIncomeStyle: boolean
  hasSingleBox: boolean
  mainHasChar: boolean
  noDataChar: boolean
  equityChar: boolean
  bunchChar: boolean
  fundChar: boolean
  fixedIncomeChar: boolean
  hasChar: boolean
  moneyMarketChar: boolean

  constructor(private readonly portfolioService: PortfolioService) {}
  ngOnInit() {
    this.portfolioSubscription = this.portfolioService
      .getPortfolioModel()
      .subscribe((model) => {
        this.portfolioModel = model
        this.determineResponsiveness()
      })
  }
  getDisplayAssetAllocationChartPortfolio() {
    if (!this.portfolioModel?.profileData?.is529) {
      return (
        /* istanbul ignore next */
        this.portfolioModel?.profileData?.isBalanced &&
        !this.portfolioModel?.profileData?.isConvertibleFund
      )
    } else {
      /* istanbul ignore next */
      return (
        this.portfolioModel?.profileData?.isBalanced &&
        this.portfolioModel?.profileData?.fundId !== '4543'
      )
    }
  }
  // eslint-disable-next-line complexity
  determineResponsiveness() {
    /* istanbul ignore next */
    this.equityStyle =
      this.portfolioModel?.profileData?.isStock ||
      this.portfolioModel?.profileData?.isBalanced
    /* istanbul ignore next */
    this.fixedIncomeStyle =
      (this.portfolioModel?.profileData?.isBond &&
        !this.portfolioModel?.profileData?.isInternational) ||
      this.portfolioModel?.profileData?.isBalanced
    /* istanbul ignore next */
    this.hasSingleBox =
      (this.equityStyle && !this.fixedIncomeStyle) ||
      (this.fixedIncomeStyle && !this.equityStyle)
    /* istanbul ignore next */
    this.mainHasChar =
      this.portfolioModel?.profileData?.fundId === '1298' ||
      (!this.portfolioModel?.profileData?.is529 &&
        this.portfolioModel?.profileData?.fundId !== '1298')
    /* istanbul ignore next */
    this.noDataChar =
      !this.portfolioModel?.characteristic?.equityCharacteristic?.fund &&
      !this.portfolioModel?.characteristic?.fundCharacteristic?.fund &&
      !this.portfolioModel?.characteristic?.moneyMarketCharacteristic?.fund &&
      !this.portfolioModel?.characteristic?.fixedIncomeCharacteristic?.fund
    /* istanbul ignore next */

    /* istanbul ignore next */
    this.bunchChar =
      this.portfolioModel?.profileData?.isBalanced &&
      !(
        this.portfolioModel?.profileData?.isFundOfFunds &&
        !this.portfolioModel?.profileData?.isHybridFund
      )
    /* istanbul ignore next */
    this.fundChar =
      !this.portfolioModel?.profileData?.is529 &&
      ((this.portfolioModel?.profileData?.isFundOfFunds &&
        !this.portfolioModel?.profileData?.isHybridFund) ||
        this.portfolioModel?.profileData?.isConvertibleFund ||
        this.portfolioModel?.profileData?.isMarketNeutralFund ||
        this.portfolioModel?.profileData?.isStableValueFund) &&
      (this.portfolioModel?.characteristic?.fundCharacteristic?.fund !==
        undefined ||
        this.portfolioModel?.characteristic?.fundCharacteristic?.benchmark !==
          undefined)
    this.determineCharacteristics()
  }
  // eslint-disable-next-line complexity
  determineCharacteristics() {
    this.equityChar =
      !this.portfolioModel?.profileData?.is529 &&
      this.portfolioModel?.profileData?.fundId !== '0517' &&
      ((this.portfolioModel?.profileData?.isStock &&
        !this.portfolioModel?.profileData?.isConvertibleFund &&
        !(
          this.portfolioModel?.profileData?.isFundOfFunds &&
          !this.portfolioModel?.profileData?.isHybridFund
        ) &&
        !this.portfolioModel?.profileData?.isExternalFund) ||
        (this.portfolioModel?.profileData?.isExternalFund &&
          (this.portfolioModel?.profileData?.isStock ||
            this.portfolioModel?.profileData?.isFundOfFunds))) &&
      ((this.portfolioModel?.profileData?.isMarketNeutralFund &&
        (this.portfolioModel?.characteristic?.equityCharacteristic?.fund !==
          undefined ||
          this.portfolioModel?.characteristic?.equityCharacteristic
            ?.benchmark !== undefined)) ||
        (!this.portfolioModel?.profileData?.isMarketNeutralFund &&
          (this.portfolioModel?.characteristic?.equityCharacteristic?.fund !==
            undefined ||
            this.portfolioModel?.characteristic?.equityCharacteristic
              ?.benchmark !== undefined)))
    /* istanbul ignore next */
    this.fixedIncomeChar =
      (this.portfolioModel?.profileData?.isBond &&
        !this.portfolioModel?.profileData?.isConvertibleFund &&
        (this.portfolioModel?.characteristic?.fixedIncomeCharacteristic
          ?.fund !== undefined ||
          this.portfolioModel?.characteristic?.fixedIncomeCharacteristic
            ?.benchmark !== undefined)) ||
      this.portfolioModel?.profileData?.fundId === '0517'
    /* istanbul ignore next */
    this.moneyMarketChar =
      !this.portfolioModel?.profileData?.is529 &&
      this.portfolioModel?.profileData?.isMoneyMarket &&
      !this.portfolioModel?.profileData?.isStableValueFund &&
      (this.portfolioModel?.characteristic?.moneyMarketCharacteristic?.fund !==
        undefined ||
        this.portfolioModel?.characteristic?.moneyMarketCharacteristic
          ?.benchmark !== undefined)
    /* istanbul ignore next */
    this.hasChar =
      !this.noDataChar &&
      this.mainHasChar &&
      (this.equityChar ||
        this.bunchChar ||
        this.fundChar ||
        this.fixedIncomeChar ||
        this.moneyMarketChar)
  }
  ngOnDestroy(): void {
    this.portfolioSubscription.unsubscribe()
  }
}
